import React from 'react';

export default function AdvisorConduct() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl textcenter md:text-4xl font-extrabold text-blue-900 mb-2">
            Advisor Code of Ethics & Conduct
          </h1>
          <p className="text-lg text-gray-700">
            All advisors, mentors, educators, and signal providers must follow these policies.
          </p>
        </div>

        {/* Conduct Rules */}
        <div className="border border-purple-200 bg-purple-50 p-6 rounded-2xl shadow mb-10">
          <ul className="list-disc space-y-6 text-gray-700 text-base px-6">
            <li> <b>No guaranteed returns</b> or misleading promises.</li>
            <li> Strictly prohibited to offer financial advice without necessary qualifications or licenses.</li>
            <li> <b>No market manipulation</b>, price pumping, or intentional misinformation.</li>
            <li> Confidential client data must remain private &amp; secured.</li>
            <li> <b>Full transparency</b> on risks, limitations &amp; conflict of interest disclosures required.</li>
            <li> Advisors must stay compliant with international financial regulations based on client jurisdictions.</li>
            <li> Any violation will result in instant suspension &amp; possible permanent blacklist status on Million2Trillion (M2T) platform.</li>
          </ul>
        </div>

        {/* CTA 
        <div className="text-center text-xl text-purple-700 font-medium mb-10">
          "We are not just protecting clients — we are protecting the reputation of all verified market professionals."
        </div>

        
        <div className="text-center pt-6">
          <h2 className="text-2xl font-bold text-purple-700 mb-4">Every advisor is responsible for trust.</h2>
          <button className="bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 text-white px-8 py-3 rounded-full font-semibold shadow">
            Agree &amp; Become Verified Advisor
          </button>
        </div>
        */}
      </div>
    </div>
  );
}
